export type ToastType = 'success' | 'error' | 'warning';

export function showToast(message: string, type: ToastType = 'error', duration = 1500) {
  try {
    const toast = document.createElement('div');
    toast.style.position = 'fixed';
    toast.style.top = '24px';
    toast.style.right = '24px';
    toast.style.zIndex = '1100';
    toast.style.padding = '8px 16px';
    toast.style.borderRadius = '12px';
    toast.style.boxShadow = 'var(--shadow-lg, 0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -2px rgba(0,0,0,0.05))';
    toast.style.color = 'var(--white, #fff)';
    toast.style.fontSize = '14px';
    toast.style.fontWeight = '600';
    toast.style.display = 'flex';
    toast.style.alignItems = 'center';
    toast.style.gap = '8px';
    const backgroundByType: Record<ToastType, string> = {
      success: 'var(--success-500, #16C787)',
      error: 'var(--error-500, #ef4444)',
      warning: 'var(--warning-500, #f59e0b)',
    };
    toast.style.background = backgroundByType[type] || backgroundByType.error;
    toast.textContent = message;

    document.body.appendChild(toast);

    setTimeout(() => {
      try {
        toast.style.transition = 'opacity 200ms ease, transform 200ms ease';
        toast.style.opacity = '0';
        toast.style.transform = 'translateY(-12px)';
        setTimeout(() => toast.remove(), 220);
      } catch (animationError) {
        console.warn('Toast fade-out failed, removing immediately', animationError);
        toast.remove();
      }
    }, Math.max(500, duration));
  } catch (error) {
    console.warn('Toast rendering failed', error);
  }
}
